import PinnedFilled from './PinnedFilled'

export default PinnedFilled
// eslint-disable-next-line import/export
export * from './PinnedFilled'
